import axios from "axios";
import React, { useEffect, useState, useRef } from "react";
import { useParams } from "react-router-dom";
import {
  Typography,
  Box,
  Button,
  IconButton,
  TextField,
  InputLabel,
  Stack,
  Card,
  CardContent,
  Divider,
} from "@mui/material";
import { ReactComponent as UploadFileIcon } from "../../../Icons/UploadFileIcon.svg";
import { ReactComponent as ImgIcon } from "../../../Icons/ImgIcon.svg";
import ClearIcon from "@mui/icons-material/Clear";
import { useNavigate } from "react-router-dom";
import { useForm, Controller, useFieldArray } from "react-hook-form";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import { ReactComponent as FormIcon } from "../../../Icons/CommonFormIcon.svg";
import CloseIcon from '@mui/icons-material/Close';
import { useSelector, useDispatch } from "react-redux";
import axiosInstance from "../../../api/axiosInstance";
import { removeData } from "../../../Redux/Feature/AdminSlice";

const EditHostel = () => {
  const { id } = useParams();
  const allLanguages = useSelector((state) => state.language.languageList)
  const dispatch = useDispatch()

  const [hostelData, setHostelData] = useState(null);

  const [loading, setLoading] = useState(true);

  const initialHostelTypes = {
    Hostel_type: "",
    room_type: [
      { room_type_name: "", six_month_cont: "", twelve_month_cont: "" },
    ],
  };

  const [HostelTypes, setHostelTypes] = useState([initialHostelTypes]);

  const [ViewsData, setViewsData] = useState([{ img: "", title: "" }]);

  const fetchHostelData = async () => {
    try {
      const response = await axiosInstance.get(
        `${process.env.REACT_APP_API_URL}gethostelbyId/${id}`
      );
      setHostelData(response?.data?.data);
    } catch (error) {
      console.log(error, "fetchHostel");
      if(error.response.status === 401 || error.response.status === 403){
        navigate('/Admin/login')
        dispatch(removeData())
    }
    }
  };

  useEffect(() => {
    if (id) {
      fetchHostelData();
    }
  }, []);

  const reactQuillRef = useRef();
  const navigate = useNavigate();

  const initialNearByMrtStation = {
    coOrdinates : {
      latitude : '',
      longitude : ''
    },
    name : {},
    walk : ''
  }

  const track = {
    coOrdinates : {
      latitude : '',
      longitude : ''
    },
    name : {
      en : '',
      'zh-tw' : '',
      zh : ''
    },
    walk : '',
    publicTransport : ''
  }

  const modules = {
    toolbar: [
      ["bold", "italic", "underline"], // toggled buttons
      [{ list: "ordered" }, { list: "bullet" }],
      ["link"], // superscript/subscript
    ],
  };

  const {
    control,
    formState: { errors },
    setValue,
    handleSubmit,
    register,
    watch,
  } = useForm({
    mode: "onTouched",
  });


  const {
    fields: mrtFields,
    append: appendMrt,
    remove: removeMrt,
  } = useFieldArray({
    control,
    name: "mrtStations",
  });
  
  const {
    fields: busFields,
    append: appendBus,
    remove: removeBus,
  } = useFieldArray({
    control,
    name: "busStations",
  });
  
  const {
    fields: trackFields,
    append: appendTrack,
    remove: removeTrack,
  } = useFieldArray({
    control,
    name: "tracks",
  });

  console.log(hostelData);
  const [bgImg, setBgImg] = useState([]);
  const [hostelImages, setHostelImages] = useState(null);

  const initialServiceFacility = {
    img: "",
    title: "",
    icon: "",
    Description: "",
  };
  const [serviceFacility, setServicesFacility] = useState([
    initialServiceFacility,
  ]);

  const Imgwatch = watch("img");
  const des = watch("serviceFacility_Image_1");

  const descriptionWatch = watch("description");

  const imgFile = useRef();

  useEffect(() => {
    if (hostelData) {
    
        setValue(`title`, hostelData?.title);
        setValue(`location`, hostelData?.location);
        setValue(`description`, hostelData?.description);
        setValue(`Location`, hostelData?.Location)
        setValue(`mrtStations`, hostelData?.nearbyMrtStation)
        setValue(`busStations`, hostelData?.nearbyBusStation)
        setValue(`tracks`, hostelData?.tracks)
  
      
      setValue("img", hostelData?.images);

      hostelData?.HostelTypes.forEach((itm, ind) => {
        allLanguages.forEach((data) => {
          setValue(`Hostel_type${ind + 1}`, itm.Hostel_type || "");
        })
        
        itm.room_type.forEach((roomItem, roomIndex) => {
          setValue(
            `room_type_${ind + 1}_${roomIndex + 1}`,
            roomItem.room_type_name || ""
          );
          setValue(
            `six_month_cont_${ind + 1}_${roomIndex + 1}`,
            roomItem.six_month_cont || ""
          );
          setValue(
            `twelve_month_cont_${ind + 1}_${roomIndex + 1}`,
            roomItem.twelve_month_cont || ""
          );
        });
      });
    }

    hostelData?.Views.forEach((item, index) => {
      setValue(`Views_Title_${index + 1}`, item?.title || "");
      setValue(`Views_Image_${index + 1}`, item?.img || "");
    });

    hostelData?.serviceFacility.forEach((item, index) => {
      setValue(`serviceFacility_Title_${index + 1}`, item?.title || "");
      setValue(`serviceFacility_des_${index + 1}`, item?.description || "");
      setValue(`serviceFacility_Image_${index + 1}`, item?.description || "");
      setValue(`serviceFacility_Icon_${index + 1}`, item?.icon || "");
    });

    setHostelTypes(hostelData?.HostelTypes);
    setServicesFacility(hostelData?.serviceFacility);
    setViewsData(hostelData?.Views);
    setLoading(false);
  }, [hostelData]);

  const [Newsdata, setNewsdata] = useState({
    title: "",
    description: "",
    img: "",
  });

  useEffect(() => {
    if (Boolean(Imgwatch)) {
      setBgImg((prev) => []);

      Array.from(Imgwatch)?.map((item, index) =>
        setBgImg((prev) => [...prev, { id: index + 1, img: item }])
      );
    }
  }, [Imgwatch]);

  const onSubmit = async (data) => {
    console.log(data, "data");
    const formData = new FormData();
    formData.append("title", JSON.stringify(data?.title));
    formData.append("description", JSON.stringify(data?.description));
    formData.append("location", JSON.stringify(data?.location));
    formData.append("Location", JSON.stringify(data?.Location))
    formData.append("mrtStations", JSON.stringify(data?.mrtStations))
    formData.append("busStations", JSON.stringify(data?.busStations))
    formData.append("tracks", JSON.stringify(data?.tracks))

    if (data.img[0].name) {
      bgImg.forEach((item, index) => {
        formData.append(`bgImg[${index}][id]`, item?.id);
        formData.append(`bgImg[${index}][img]`, item?.img);
      });
    }

    HostelTypes.forEach((item, index) => {
      formData.append(`HostelTypes[${index}][id]`, index + 1);
      formData.append(
        `HostelTypes[${index}][Hostel_type]`,
        JSON.stringify(data[`Hostel_type${index + 1}`])
      );

      item?.room_type.forEach((itm, ind) => {
        formData.append(
          `HostelTypes[${index}][room_type][${ind}][id]`,
          ind + 1
        );
        formData.append(
          `HostelTypes[${index}][room_type][${ind}][room_type_name]`,
          JSON.stringify(data[`room_type_${index + 1}_${ind + 1}`])
        );
        formData.append(
          `HostelTypes[${index}][room_type][${ind}][six_month_cont]`,
          data[`six_month_cont_${index + 1}_${ind + 1}`]
        );
        formData.append(
          `HostelTypes[${index}][room_type][${ind}][twelve_month_cont]`,
          data[`twelve_month_cont_${index + 1}_${ind + 1}`]
        );

        //  itm?.rooms.forEach((room, roomInd) => {
        //   formData.append(
        //     `HostelTypes[${index}][room_type][${ind}][rooms][${roomInd}][id]`,
        //     roomInd + 1
        //   );
        //   formData.append(
        //     `HostelTypes[${index}][room_type][${ind}][rooms][${roomInd}][roomName]`,
        //     data[`room_name_${index + 1}_${ind + 1}_${roomInd + 1}`]
        //   );
        //   formData.append(
        //     `HostelTypes[${index}][room_type][${ind}][rooms][${roomInd}][totalSlots]`,
        //     data[`room_slots_${index + 1}_${ind + 1}_${roomInd + 1}`]
        //   );
        //   formData.append(
        //     `HostelTypes[${index}][room_type][${ind}][rooms][${roomInd}][availableSlots]`,
        //     data[`room_slots_${index + 1}_${ind + 1}_${roomInd + 1}`]
        //   );
        //   formData.append(`HostelTypes[${index}][room_type][${ind}][rooms][${roomInd}][members]`, JSON.stringify([]));
        //   // room.members.forEach((member, memInd) => {
        //   //   formData.append(
        //   //     `HostelTypes[${index}][room_type][${ind}][rooms][${roomInd}][members][${memInd}]`,
        //   //     member || ''
        //   //   );
        //   // });
        // });
      });
    });

    serviceFacility.forEach((item, index) => {
      formData.append(`serviceFacility[${index}][id]`, index + 1);

      if (item.img == "") {
        formData.append(
          `serviceFacility[${index}][img]`,
          data[`serviceFacility_Image_${index + 1}`]
        );
      }

      formData.append(
        `serviceFacility[${index}][title]`,
        JSON.stringify(data[`serviceFacility_Title_${index + 1}`])
      );

      if (item.icon == "") {
        formData.append(
          `serviceFacility[${index}][icon]`,
          data[`serviceFacility_Icon_${index + 1}`]
        );
      }

      formData.append(
        `serviceFacility[${index}][Description]`,
        JSON.stringify(data[`serviceFacility_des_${index + 1}`])
      );
    });

    ViewsData.forEach((item, index) => {
      formData.append(`Views[${index}][id]`, index + 1);

      if (item.img == "") {
        formData.append(
          `Views[${index}][img]`,
          data[`Views_Image_${index + 1}`]
        );
      }

      formData.append(
        `Views[${index}][title]`,
        JSON.stringify(data[`Views_Title_${index + 1}`])
      );
    });

    try {
      const response = await axiosInstance.put(
        `${process.env.REACT_APP_API_URL}editHostel/${id}`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );
      navigate("/Admin/Hostellist");
      console.log(response);
    } catch (error) {
      console.log(error);
      if(error.response.status === 401 || error.response.status === 403){
        navigate('/Admin/login')
        dispatch(removeData())
    }
    }
  };

  const handleAddRoomType = (ind) => {
    setHostelTypes((prev) => {
      const data = HostelTypes.map((itm, index) => {
        if (index === ind) {
          return {
            ...itm,
            room_type: [
              ...itm["room_type"],
              { room_type_name: "", six_month_cont: "", twelve_month_cont: "" },
            ],
          };
        }
        return itm;
      });
      return data;
    });
  };


  const handleAddRoom = (hostelIndex, roomTypeIndex) => {
    setHostelTypes((prev) => {
      const updatedHostelTypes = prev.map((hostel, index) => {
        if (index === hostelIndex) {
          const updatedRoomTypes = hostel.room_type.map((roomType, rIndex) => {
            if (rIndex === roomTypeIndex) {
              return {
                ...roomType,
                rooms: [
                  ...roomType.rooms,
                  {
                    id: roomType.rooms.length + 1,
                    roomName : '',
                    totalSlots: '',
                    availableSlots: '',
                    members: []
                  }
                ]
              };
            }
            return roomType;
          });
          return { ...hostel, room_type: updatedRoomTypes };
        }
        return hostel;
      });
      return updatedHostelTypes;
    });
  };
  

  const handleDeleteRoom = (hostelIndex, roomTypeIndex, roomIndex) => {
    setHostelTypes((prev) => {
      const updatedHostelTypes = prev.map((hostel, index) => {
        if (index === hostelIndex) {
          const updatedRoomTypes = hostel.room_type.map((roomType, rIndex) => {
           
            if (rIndex === roomTypeIndex) {
              const roomMembers = roomType.rooms.filter((room, rIndex) => rIndex === roomIndex)
              const members = Array.isArray(roomMembers[0]?.members) 
                ? roomMembers[0]?.members 
                : JSON.parse(roomMembers[0]?.members);
              if(members?.length > 0){
                alert("Room member exist")
              }else {
                const updatedRooms = roomType.rooms.filter(
                  (room, rIndex) => rIndex !== roomIndex
                );
                console.log(updatedRooms)
                return { ...roomType, rooms: updatedRooms };
              }
            }
            return roomType;
          });
          console.log(updatedRoomTypes)
          return { ...hostel, room_type: updatedRoomTypes };
        }
        return hostel;
      });
      return updatedHostelTypes;
    });
  };


  const handleDeleteHostelType = (ind) => {
    const data = HostelTypes.filter((itm, index) => ind !== index);
    setHostelTypes(data);
  };

  const handleDeleteRoomType = (ind, subind) => {
    setHostelTypes((prev) => {
      const data = HostelTypes.map((itm, index) => {
        if (index === ind) {
          const datas = itm?.room_type?.filter(
            (subitm, subindex) => subind !== subindex
          );
          return { ...itm, room_type: datas };
        }
        return itm;
      });
      return data;
    });
  };

  const handleDeleteServicesFacility = (ind) => {
    const data = serviceFacility.filter((itm, index) => ind !== index);
    setServicesFacility(data);
  };

  const handleDeleteViews = (ind) => {
    const data = ViewsData.filter((itm, index) => ind !== index);
    setViewsData(data);
  };

  const deleteFirstImage = (id) => {
    let updatedFiles = Array.from(Imgwatch);
    updatedFiles = updatedFiles.filter((file, index) => index !== id);
    setValue("img", updatedFiles);
  };

  const handleServiceImageDelete = (index) => {
    const newServiceFacility = [...serviceFacility];

    newServiceFacility[index] = {
      ...newServiceFacility[index],
      img: "",
    };

    setServicesFacility(newServiceFacility);
  };

  const handleServiceIconDelete = (index) => {
    const newServiceFacility = [...serviceFacility];

    newServiceFacility[index] = {
      ...newServiceFacility[index],
      icon: "",
    };

    setServicesFacility(newServiceFacility);
  };

  const handleViewsImageDelete = (index) => {
    const newViewsData = [...ViewsData];

    newViewsData[index] = {
      ...newViewsData[index],
      img: "",
    };

    setViewsData(newViewsData);
  };

  const addNewMrtStation = () => {
    appendMrt(initialNearByMrtStation)
  }

  const addNewBusStation = () => {
    appendBus(initialNearByMrtStation)
  }

  const addNewTrack = () => {
    appendTrack(track)
  }

  const handleDeleteMrtStation = (ind) => {
    removeMrt(ind)
};

const handleDeleteBusStation = (ind) => {
    removeBus(ind)
}

const handleDeleteTrack = (ind) => {
    removeTrack(ind)
}

  return (
    <>
      {loading ? (
        <>
          <p>Loading...</p>
        </>
      ) : (
        <>
          <Box sx={{ display: "flex", justifyContent: "center" }}>
            <Card
              sx={{
                width: "90%",
                border: "1px solid #E5E7EB",
                borderRadius: "6px",
              }}
            >
              <CardContent style={{ padding: 0, margin: 0 }}>
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "flex-start",
                    alignItems: "center",
                    backgroundColor: "#FCFCFD",
                    padding: 2,
                    border: "1px solid #E5E7EB",
                    borderRadius: "6px 6px 0px 0px",
                  }}
                >
                  <FormIcon style={{ marginRight: "10px" }} />
                  <Typography variant="h6_1">Hostel Details</Typography>
                </Box>

                <form onSubmit={handleSubmit(onSubmit)}>
                {allLanguages.map((lang) => (
              <>
               <Box sx={{mb: 2}} key={lang.value} >
        <Typography sx={{fontWeight : 700, fontSize : '1.4rem', mt : 2, ml : 2}}>{lang.name}</Typography>
              <Box style={{ padding: "25px 17px 17px 17px" }}>
                <InputLabel
                  sx={{
                    mb: 1,
                    fontSize: "18px",
                    fontWeight: 600,
                    color: "black",
                  }}
                >
                  {errors?.title?.[lang.value] ? "Title*" : "Title"}
                </InputLabel>
                <Controller
                  name={`title.${lang.value}`}
                  rules={{ required: true }}
                  control={control}
                  render={({ field }) => (
                    <TextField
                      {...field}
                      error={Boolean(errors?.title?.[lang.value]) ? true : false}
                      placeholder="Enter title"
                      sx={{
                        mt: 0,
                        backgroundColor: "rgb(249, 250, 251)",
                        borderRadius: 0,
                        "& .MuiInputBase-input": {
                          color: errors?.title?.[lang.value] ? "red" : "black",
                        },
                        "& .MuiOutlinedInput-root": {
                          "& fieldset": {
                            borderColor: errors?.title?.[lang.value]
                              ? "#ff5e74"
                              : "rgba(0, 0, 0, 0.23)",
                          },
                          "&:hover fieldset": {
                            borderColor: errors?.title?.[lang.value]
                              ? "#ff5e74"
                              : "rgba(0, 0, 0, 0.23)",
                          },
                          "&.Mui-focused fieldset": {
                            borderColor: errors?.title?.[lang.value]
                              ? "#ff5e74"
                              : "rgba(0, 0, 0, 0.23)",
                          },
                        },
                      }}
                    />
                  )}
                />
                {errors?.title?.[lang.value] ? (
                  <Typography style={{ color: "#ff5e74", margin: "0.3rem" }}>
                    Please enter title
                  </Typography>
                ) : null}
              </Box>

              <Box style={{ padding: "0px 17px 17px" }}>
                <InputLabel
                  sx={{
                    mb: 1,
                    fontSize: "18px",
                    fontWeight: 600,
                    color: "black",
                  }}
                >
                  {errors?.location?.[lang.value] ? "Location*" : "Location"}
                </InputLabel>
                <Controller
                  name={`location.${lang.value}`}
                  rules={{ required: true }}
                  control={control}
                  render={({ field }) => (
                    <TextField
                      placeholder="Enter location"
                      error={Boolean(errors?.location?.[lang.value]) ? true : false}
                      {...field}
                      sx={{
                        mt: 0,
                        backgroundColor: "rgb(249, 250, 251)",
                        borderRadius: 0,
                        "& .MuiInputBase-input": {
                          color: errors?.location?.[lang.value] ? "red" : "black",
                        },
                        "& .MuiOutlinedInput-root": {
                          "& fieldset": {
                            borderColor: errors?.location?.[lang.value]
                              ? "#ff5e74"
                              : "rgba(0, 0, 0, 0.23)",
                          },
                          "&:hover fieldset": {
                            borderColor: errors?.location?.[lang.value]
                              ? "#ff5e74"
                              : "rgba(0, 0, 0, 0.23)",
                          },
                          "&.Mui-focused fieldset": {
                            borderColor: errors?.location?.[lang.value]
                              ? "#ff5e74"
                              : "rgba(0, 0, 0, 0.23)",
                          },
                        },
                      }}
                    />
                  )}
                />
                {errors?.location?.[lang.value] ? (
                  <Typography style={{ color: "#ff5e74", margin: "0.3rem" }}>
                    Please enter location
                  </Typography>
                ) : null}
              </Box>

              <Box style={{ padding: "0px 17px 17px" }}>
                <InputLabel
                  sx={{
                    mb: 1,
                    fontSize: "18px",
                    fontWeight: 600,
                    color: "black",
                  }}
                >
                  {errors?.description?.[lang.value] ? "Description*" : "Description"}
                </InputLabel>
                <Controller
                  name={`description.${lang.value}`}
                  rules={{
                    validate: (value) => {
                      const strippedValue = value.replace(/<(.|\n)*?>/g, '').trim();
                      return strippedValue.length > 0 || "Description is required";
                    },
                  }}
                  control={control}
                  render={({ field }) => (
                    <ReactQuill
                      style={{ height: "180px" }}
                      modules={modules}
                      maxLength={3000}
                      {...field}
                    />
                  )}
                />
              </Box>

              <Box style={{ marginTop: "2rem", marginLeft: "1rem" }}>
                {errors?.description?.[lang.value] ? (
                  <Typography style={{ color: "#ff5e74", margin: "0.3rem" }}>
                    {errors?.description?.[lang.value]?.message}
                  </Typography>
                ) : null}
              </Box>
              </Box>
              <Divider sx={{mt: 2, mb : 2}}/>
              </>
              
            ))}

                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "flex-start",
                      alignItems: "center",
                      backgroundColor: "#FCFCFD",
                      padding: 2,
                      border: "1px solid #E5E7EB",
                      marginTop: 7,
                    }}
                  >
                    <FormIcon style={{ marginRight: "10px" }} />
                    <Typography
                      sx={{
                        fontSize: "20px",
                        fontWeight: 600,
                        color: "black",
                      }}
                    >
                      Hostel Image
                    </Typography>
                  </Box>

                  {Boolean(Imgwatch?.length > 0) ? (
                    Array.from(Imgwatch)?.map((item, index) => (
                      <Box style={{ padding: "0px 17px 17px" }}>
                        <Stack
                          mt={2}
                          direction="row"
                          justifyContent="space-between"
                          alignItems="center"
                          padding="23px"
                          borderRadius="8px"
                          sx={{ border: ".5px solid #1A2461" }}
                        >
                          <Typography
                            variant="h9_1"
                            sx={{
                              display: "flex",
                              alignItems: "center",
                              gap: "10px",
                            }}
                          >
                            <ImgIcon />
                            {item?.src || item?.name}
                          </Typography>
                          <ClearIcon
                            onClick={() => deleteFirstImage(index)}
                            sx={{ color: "#1A2461" }}
                          />
                        </Stack>
                      </Box>
                    ))
                  ) : (
                    <Box
                      xs={12}
                      onClick={() => imgFile.current.click()}
                      sx={{
                        border: Boolean(errors.img)
                          ? "1px dashed red"
                          : "1px dashed #1A2461",
                        height: "200px",
                        borderRadius: "8px",
                        backgroundColor: "#F9FBFF",
                        margin: "20px 17px 17px",
                      }}
                    >
                      <Stack
                        direction="column"
                        alignItems="center"
                        justifyContent="center"
                        height="100%"
                      >
                        <Stack
                          direction="row"
                          alignItems="center"
                          justifyContent="center"
                          sx={{
                            height: "100px",
                            width: "100px",
                            borderRadius: "100px",
                            backgroundColor: "#F2F2F2",
                          }}
                        >
                          <UploadFileIcon fill="#1A2461" />
                        </Stack>
                        <Stack     
                          mt={2}
                          direction="row"
                          alignItems="center"
                          gap="5px"
                        >
                          <Typography variant="h9_1">
                            Click to upload
                          </Typography>
                        </Stack>
                        <Typography variant="h9_5">
                          Allowed formats - JPEG, PNG
                        </Typography>
                      </Stack>
                    </Box>
                  )}
                  <Controller
                    name="img"
                    rules={{ required: true }}
                    control={control}
                    render={({ field }) => (
                      <input
                        type="file"
                        accept="image/*"
                        onChange={(e) => {
                          field.onChange(e.target.files);
                        }}
                        ref={(e) => {
                          imgFile.current = e;
                        }}
                        hidden
                        multiple
                      />
                    )}
                  />

                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "flex-start",
                      alignItems: "center",
                      backgroundColor: "#FCFCFD",
                      padding: 2,
                      border: "1px solid #E5E7EB",
                      marginTop: 7,
                    }}
                  >
                    <FormIcon style={{ marginRight: "10px" }} />
                    <Typography
                      sx={{
                        fontSize: "20px",
                        fontWeight: 600,
                        color: "black",
                      }}
                    >
                      Pricing
                    </Typography>
                  </Box>

                  {HostelTypes?.map((itm, ind) => (
                    <React.Fragment key={ind}>
                      <Card sx={{
                            width: "100%",
                            border: "1px solid #E5E7EB",
                            borderRadius: "6px",
                            margin: "20px 10px",
                            boxShadow: "0px 1px 10px -7px rgba(0,0,0,0.75)",
                           
                          }}>
                  <CardContent>
                      <Box style={{ padding: "25px 17px 17px 17px", position : 'relative' }}>

                      <Box sx={{position : 'absolute', top : 0, right : 0}}>
                      {ind > 0 && (
                        <IconButton onClick={() => handleDeleteHostelType(ind)}>
                          {" "}
                          <ClearIcon
                            sx={{ color: "blue", fontSize: "30px" }}
                          />
                        </IconButton>
                      )}
                      </Box>
                    
                      {allLanguages.map((lang) => (
                        <>
                      
                        <Box sx={{mb: 2}} key={lang.value} >
                          <Typography sx={{fontWeight : 700, fontSize : '1.4rem', mt : 2}}>{lang.name}</Typography>
                          <Stack
                      direction="row"
                      alignItems="center"
                      justifyContent="space-between"
                    >
                      <InputLabel
                        sx={{
                          mb: 1,
                          mt : 1,
                          fontSize: "18px",
                          fontWeight: 600,
                          color: "black",
                        }}
                      >
                        {Boolean(errors[`Hostel_type${ind + 1}`]?.[lang.value])
                          ? "Hostel Type*"
                          : "Hostel Type"}
                      </InputLabel>

                      
                    </Stack>

                    <Controller
                      name={`Hostel_type${ind + 1}.${lang.value}`}
                      rules={{ required: true }}
                      control={control}
                      render={({ field }) => (
                        <TextField
                          placeholder="Enter hostel type"
                          error={
                            Boolean(errors[`Hostel_type${ind + 1}`]?.[lang.value])
                              ? true
                              : false
                          }
                          {...field}
                          sx={{
                            mt: 0,
                            backgroundColor: "rgb(249, 250, 251)",
                            borderRadius: 0,
                            "& .MuiInputBase-input": {
                              color: Boolean(errors[`Hostel_type${ind + 1}`]?.[lang.value])
                                ? "red"
                                : "black",
                            },
                            "& .MuiOutlinedInput-root": {
                              "& fieldset": {
                                borderColor: Boolean(
                                  errors[`Hostel_type${ind + 1}`]?.[lang.value]
                                )
                                  ? "#ff5e74"
                                  : "rgba(0, 0, 0, 0.23)",
                              },
                              "&:hover fieldset": {
                                borderColor: Boolean(
                                  errors[`Hostel_type${ind + 1}`]?.[lang.value]
                                )
                                  ? "#ff5e74"
                                  : "rgba(0, 0, 0, 0.23)",
                              },
                              "&.Mui-focused fieldset": {
                                borderColor: Boolean(
                                  errors[`Hostel_type${ind + 1}`]?.[lang.value]
                                )
                                  ? "#ff5e74"
                                  : "rgba(0, 0, 0, 0.23)",
                              },
                            },
                          }}
                        />
                      )}
                    />
                    {Boolean(errors[`Hostel_type${ind + 1}`]?.[lang.value]) ? (
                      <Typography
                        style={{ color: "#ff5e74", margin: "0.3rem" }}
                      >
                        Please enter hostel type
                      </Typography>
                    ) : null}

                    <Divider sx={{mt : 2, mb : 2}}/>
                    </Box>
                    </>
                      ))}

                        {itm?.room_type?.map((item, index) => (
                          <Card
                            sx={{
                              width: "100%",
                              border: "1px solid #E5E7EB",
                              borderRadius: "6px",
                              margin: "15px 0px",
                              boxShadow: "0px 1px 10px -7px rgba(0,0,0,0.75)",
                              position : 'relative'
                            }}
                          >
                            <CardContent>
                            <Box sx={{position : 'absolute', top : 0, right : 0}}>
                            {index > 0 && (
                                <IconButton
                                  onClick={() =>
                                    handleDeleteRoomType(ind, index)
                                  }
                                >
                                  {" "}
                                  <ClearIcon
                                    sx={{ color: "#f37777", fontSize: "30px" }}
                                  />
                                </IconButton>
                              )}
                              </Box>
                              <React.Fragment key={index}>
                              {allLanguages.map((lang) => (
                            <>
                             <Box sx={{mb: 2}} key={lang.value} >
                          <Typography sx={{fontWeight : 700, fontSize : '1.4rem', mt : 2}}>{lang.name}</Typography>
                            <Stack
                              direction="row"
                              alignItems="center"
                              justifyContent="space-between"
                              style={{ marginTop: "20px" }}
                            >
                              <InputLabel
                                sx={{
                                  mb: 1,
                                  fontSize: "18px",
                                  fontWeight: 600,
                                  color: "black",
                                }}
                              >
                                {Boolean(
                                  errors[`room_type_${ind + 1}_${index + 1}`]?.[lang.value]
                                )
                                  ? "Room Type*"
                                  : "Room Type"}
                              </InputLabel>

                              
                            </Stack>
                            <Controller
                              name={`room_type_${ind + 1}_${index + 1}.${lang.value}`}
                              rules={{ required: true }}
                              control={control}
                              render={({ field }) => (
                                <TextField
                                  placeholder="Enter room type"
                                  error={
                                    Boolean(
                                      errors[
                                        `room_type_${ind + 1}_${index + 1}`
                                      ]?.[lang.value]
                                    )
                                      ? true
                                      : false
                                  }
                                  {...field}
                                  sx={{
                                    mt: 0,
                                    backgroundColor: "rgb(249, 250, 251)",
                                    borderRadius: 0,
                                    "& .MuiInputBase-input": {
                                      color: Boolean(
                                        errors[
                                          `room_type_${ind + 1}_${index + 1}`
                                        ]?.[lang.value]
                                      )
                                        ? "red"
                                        : "black",
                                    },
                                    "& .MuiOutlinedInput-root": {
                                      "& fieldset": {
                                        borderColor: Boolean(
                                          errors[
                                            `room_type_${ind + 1}_${index + 1}`
                                          ]?.[lang.value]
                                        )
                                          ? "#ff5e74"
                                          : "rgba(0, 0, 0, 0.23)",
                                      },
                                      "&:hover fieldset": {
                                        borderColor: Boolean(
                                          errors[
                                            `room_type_${ind + 1}_${index + 1}`
                                          ]?.[lang.value]
                                        )
                                          ? "#ff5e74"
                                          : "rgba(0, 0, 0, 0.23)",
                                      },
                                      "&.Mui-focused fieldset": {
                                        borderColor: Boolean(
                                          errors[
                                            `room_type_${ind + 1}_${index + 1}`
                                          ]?.[lang.value]
                                        )
                                          ? "#ff5e74"
                                          : "rgba(0, 0, 0, 0.23)",
                                      },
                                    },
                                  }}
                                />
                              )}
                            />
                            {Boolean(
                              errors[`room_type_${ind + 1}_${index + 1}`]?.[lang.value]
                            ) ? (
                              <Typography
                                style={{ color: "#ff5e74", margin: "0.3rem" }}
                              >
                                Please enter room type
                              </Typography>
                            ) : null}
                            </Box>
                            <Divider sx={{mt : 2, mb : 2}}/>
                            </>
                          ))}
                                <Box
                                  sx={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                    alignContent: "center",
                                  }}
                                  style={{ gap: "10px" }}
                                >
                                  <Box style={{ width: "100%" }}>
                                    <InputLabel
                                      sx={{
                                        mt: "20px",
                                        mb: 1,
                                        fontSize: "18px",
                                        fontWeight: 600,
                                        color: "black",
                                      }}
                                    >
                                      {Boolean(
                                        errors[
                                          `six_month_cont_${ind + 1}_${
                                            index + 1
                                          }`
                                        ]
                                      )
                                        ? "6 month contract*"
                                        : "6 month contract"}
                                    </InputLabel>

                                    <Controller
                                      name={`six_month_cont_${ind + 1}_${
                                        index + 1
                                      }`}
                                      rules={{ required: true }}
                                      defaultValue={item?.six_month_cont || ""}
                                      control={control}
                                      render={({ field }) => (
                                        <TextField
                                          inputProps={{
                                            inputMode: "numeric",
                                            pattern: "[0-9]*",
                                            maxLength: 10, 
                                          }}
                                          onInput={(e) => {
                                            e.target.value =
                                              e.target.value.replace(
                                                /[^0-9]/g,
                                                ""
                                              );
                                          }}
                                          placeholder="Enter amount"
                                          type="text"
                                          error={Boolean(
                                            errors[
                                              `six_month_cont_${ind + 1}_${
                                                index + 1
                                              }`
                                            ]
                                          )}
                                          {...field}
                                          sx={{
                                            mt: 0,
                                            backgroundColor:
                                              "rgb(249, 250, 251)",
                                            borderRadius: 0,
                                            "& .MuiInputBase-input": {
                                              color: Boolean(
                                                errors[
                                                  `six_month_cont_${ind + 1}_${
                                                    index + 1
                                                  }`
                                                ]
                                              )
                                                ? "red"
                                                : "black",
                                            },
                                            "& .MuiOutlinedInput-root": {
                                              "& fieldset": {
                                                borderColor: Boolean(
                                                  errors[
                                                    `six_month_cont_${
                                                      ind + 1
                                                    }_${index + 1}`
                                                  ]
                                                )
                                                  ? "#ff5e74"
                                                  : "rgba(0, 0, 0, 0.23)",
                                              },
                                              "&:hover fieldset": {
                                                borderColor: Boolean(
                                                  errors[
                                                    `six_month_cont_${
                                                      ind + 1
                                                    }_${index + 1}`
                                                  ]
                                                )
                                                  ? "#ff5e74"
                                                  : "rgba(0, 0, 0, 0.23)",
                                              },
                                              "&.Mui-focused fieldset": {
                                                borderColor: Boolean(
                                                  errors[
                                                    `six_month_cont_${
                                                      ind + 1
                                                    }_${index + 1}`
                                                  ]
                                                )
                                                  ? "#ff5e74"
                                                  : "rgba(0, 0, 0, 0.23)",
                                              },
                                            },
                                          }}
                                        />
                                      )}
                                    />
                                    {Boolean(
                                      errors[
                                        `six_month_cont_${ind + 1}_${index + 1}`
                                      ]
                                    ) ? (
                                      <Typography
                                        style={{
                                          color: "#ff5e74",
                                          margin: "0.3rem",
                                        }}
                                      >
                                        Please enter 6 month contract amount
                                      </Typography>
                                    ) : null}
                                  </Box>

                                  <Box style={{ width: "100%" }}>
                                    <InputLabel
                                      sx={{
                                        mt: "20px",
                                        mb: 1,
                                        fontSize: "18px",
                                        fontWeight: 600,
                                        color: "black",
                                      }}
                                    >
                                      {Boolean(
                                        errors[
                                          `twelve_month_cont_${ind + 1}_${
                                            index + 1
                                          }`
                                        ]
                                      )
                                        ? "12 month contract*"
                                        : "12 month contract"}
                                    </InputLabel>

                                    <Controller
                                      name={`twelve_month_cont_${ind + 1}_${
                                        index + 1
                                      }`}
                                      rules={{ required: true }}
                                      defaultValue={
                                        item?.twelve_month_cont || ""
                                      }
                                      control={control}
                                      render={({ field }) => (
                                        <TextField
                                          inputProps={{
                                            inputMode: "numeric",
                                            pattern: "[0-9]*",
                                            maxLength: 10,
                                          }}
                                          onInput={(e) => {
                                            e.target.value =
                                              e.target.value.replace(
                                                /[^0-9]/g,
                                                ""
                                              );
                                          }}
                                          placeholder="Enter amount"
                                          type="text"
                                          error={Boolean(
                                            errors[
                                              `twelve_month_cont_${ind + 1}_${
                                                index + 1
                                              }`
                                            ]
                                          )}
                                          {...field}
                                          sx={{
                                            mt: 0,
                                            backgroundColor:
                                              "rgb(249, 250, 251)",
                                            borderRadius: 0,
                                            "& .MuiInputBase-input": {
                                              color: Boolean(
                                                errors[
                                                  `twelve_month_cont_${
                                                    ind + 1
                                                  }_${index + 1}`
                                                ]
                                              )
                                                ? "red"
                                                : "black",
                                            },
                                            "& .MuiOutlinedInput-root": {
                                              "& fieldset": {
                                                borderColor: Boolean(
                                                  errors[
                                                    `twelve_month_cont_${
                                                      ind + 1
                                                    }_${index + 1}`
                                                  ]
                                                )
                                                  ? "#ff5e74"
                                                  : "rgba(0, 0, 0, 0.23)",
                                              },
                                              "&:hover fieldset": {
                                                borderColor: Boolean(
                                                  errors[
                                                    `twelve_month_cont_${
                                                      ind + 1
                                                    }_${index + 1}`
                                                  ]
                                                )
                                                  ? "#ff5e74"
                                                  : "rgba(0, 0, 0, 0.23)",
                                              },
                                              "&.Mui-focused fieldset": {
                                                borderColor: Boolean(
                                                  errors[
                                                    `twelve_month_cont_${
                                                      ind + 1
                                                    }_${index + 1}`
                                                  ]
                                                )
                                                  ? "#ff5e74"
                                                  : "rgba(0, 0, 0, 0.23)",
                                              },
                                            },
                                          }}
                                        />
                                      )}
                                    />
                                    {Boolean(
                                      errors[
                                        `twelve_month_cont_${ind + 1}_${
                                          index + 1
                                        }`
                                      ]
                                    ) ? (
                                      <Typography
                                        style={{
                                          color: "#ff5e74",
                                          margin: "0.3rem",
                                        }}
                                      >
                                        Please enter 12 month contract amount
                                      </Typography>
                                    ) : null}
                                  </Box>
                                </Box>


                                 {/* {item.rooms.map((room, roomIndex) => (
                              <Card sx={{mt : 2, background : 'linear-gradient(30deg, rgba(243,243,243,1) 0%, rgba(248,248,248,1) 40%, rgba(253,253,253,1) 100%)'}}>
                              <CardContent>
                              <Box sx={{justifyContent : 'flex-end', display : roomIndex === 0 ? 'none' : 'flex'}}>
                                <Button onClick={() => handleDeleteRoom(ind, index, roomIndex)}><CloseIcon /></Button>
                                </Box>
                            <Box key={roomIndex} sx={{ display : 'flex', justifyContent : 'space-between', mb : 2 }}>
                             
                              <Box sx={{width : '49%'}}>
                              <InputLabel
                                  sx={{
                                    mt: "20px",
                                    mb: 1,
                                    fontSize: "18px",
                                    fontWeight: 600,
                                    color: "black",
                                  }}
                                >
                                  {Boolean(
                                    errors[
                                      `room_name_${ind + 1}_${index + 1}_${roomIndex + 1}`
                                    ]
                                  )
                                    ? "Room name*"
                                    : "Room name"}
                                </InputLabel>
                              <Controller
                                name={`room_name_${ind + 1}_${index + 1}_${roomIndex + 1}`}
                                defaultValue={room?.roomName || ""}
                                rules={{ required: false }}
                                control={control}
                                render={({ field }) => (
                                  <TextField
                                    placeholder="Enter room name"
                                    {...field}
                                    sx={{
                                      mt: 0,
                                      backgroundColor: "rgb(249, 250, 251)",
                                      borderRadius: 0,
                                      "& .MuiInputBase-input": {
                                        color: Boolean(
                                          errors[
                                            `room_name_${ind + 1}_${index + 1}_${roomIndex + 1}`
                                          ]
                                        )
                                          ? "red"
                                          : "black",
                                      },
                                      "& .MuiOutlinedInput-root": {
                                        "& fieldset": {
                                          borderColor: Boolean(
                                            errors[
                                              `room_name_${ind + 1}_${index + 1}_${roomIndex + 1}`
                                            ]
                                          )
                                            ? "#ff5e74"
                                            : "rgba(0, 0, 0, 0.23)",
                                        },
                                        "&:hover fieldset": {
                                          borderColor: Boolean(
                                            errors[
                                              `room_name_${ind + 1}_${index + 1}_${roomIndex + 1}`
                                            ]
                                          )
                                            ? "#ff5e74"
                                            : "rgba(0, 0, 0, 0.23)",
                                        },
                                        "&.Mui-focused fieldset": {
                                          borderColor: Boolean(
                                            errors[
                                              `room_name_${ind + 1}_${index + 1}_${roomIndex + 1}`
                                            ]
                                          )
                                            ? "#ff5e74"
                                            : "rgba(0, 0, 0, 0.23)",
                                        },
                                      },
                                    }}
                                  />
                                )}
                              />
                              {Boolean(
                                  errors[
                                    `room_name_${ind + 1}_${index + 1}_${roomIndex + 1}`
                                  ]
                                ) ? (
                                  <Typography
                                    style={{
                                      color: "#ff5e74",
                                      margin: "0.3rem",
                                    }}
                                  >
                                    Please enter room name
                                  </Typography>
                                ) : null}
                                </Box>

                                  <Box sx={{width : '49%'}}>
                                  <InputLabel
                                  sx={{
                                    mt: "20px",
                                    mb: 1,
                                    fontSize: "18px",
                                    fontWeight: 600,
                                    color: "black",
                                  }}
                                >
                                  {Boolean(
                                    errors[
                                      `room_slots_${ind + 1}_${index + 1}_${roomIndex + 1}`
                                    ]
                                  )
                                    ? "Room slots*"
                                    : "Room slots"}
                                </InputLabel>
                                <Controller
                                  name={`room_slots_${ind + 1}_${index + 1}_${roomIndex + 1}`}
                                  rules={{ required: true }}
                                  defaultValue={room?.totalSlots || ""}
                                  control={control}
                                  render={({ field }) => (
                                    <TextField
                                      inputProps={{
                                        inputMode: 'numeric',
                                        pattern: '[0-9]*',
                                      }}
                                      onInput={(e) => {
                                        e.target.value = e.target.value.replace(/[^0-9]/g, '');
                                      }}
                                      type="text"
                                      placeholder="Enter total slots"
                                      {...field}
                                      sx={{
                                        mt: 0,
                                        backgroundColor: "rgb(249, 250, 251)",
                                        borderRadius: 0,
                                        "& .MuiInputBase-input": {
                                          color: Boolean(
                                            errors[
                                              `room_slots_${ind + 1}_${index + 1}_${roomIndex + 1}`
                                            ]
                                          )
                                            ? "red"
                                            : "black",
                                        },
                                        "& .MuiOutlinedInput-root": {
                                          "& fieldset": {
                                            borderColor: Boolean(
                                              errors[
                                                `room_slots_${ind + 1}_${index + 1}_${roomIndex + 1}`
                                              ]
                                            )
                                              ? "#ff5e74"
                                              : "rgba(0, 0, 0, 0.23)",
                                          },
                                          "&:hover fieldset": {
                                            borderColor: Boolean(
                                              errors[
                                                `room_slots_${ind + 1}_${index + 1}_${roomIndex + 1}`
                                              ]
                                            )
                                              ? "#ff5e74"
                                              : "rgba(0, 0, 0, 0.23)",
                                          },
                                          "&.Mui-focused fieldset": {
                                            borderColor: Boolean(
                                              errors[
                                                `room_slots_${ind + 1}_${index + 1}_${roomIndex + 1}`
                                              ]
                                            )
                                              ? "#ff5e74"
                                              : "rgba(0, 0, 0, 0.23)",
                                          },
                                        },
                                      }}
                                    />
                                  )}
                                />

                                {Boolean(
                                  errors[
                                    `room_slots_${ind + 1}_${index + 1}_${roomIndex + 1}`
                                  ]
                                ) ? (
                                  <Typography
                                    style={{
                                      color: "#ff5e74",
                                      margin: "0.3rem",
                                    }}
                                  >
                                    Please enter room slots
                                  </Typography>
                                ) : null}
                                </Box>
                              </Box>

                                
                              </CardContent>
                            </Card>
                            ))}
                           
                            <Box sx={{mt : 2, display : 'flex', justifyContent : 'flex-end'}}>
                            <Button variant='contained' onClick={() => handleAddRoom(ind, index)}>Add room</Button>
                            </Box> */}


                                {index === itm.room_type.length - 1 && index < 19 && (
                                  <Box
                                    sx={{
                                      display: "flex",
                                      justifyContent: "center",
                                      mt: "40px",
                                    }}
                                  >
                                    <Button
                                      style={{
                                        padding: "6px 0px",
                                        width: "25%",
                                        fontSize: "1rem",
                                      }}
                                      onClick={() => {
                                        handleAddRoomType(ind);
                                      }}
                                      variant="outlined"
                                    >
                                      Add more Room type
                                    </Button>
                                  </Box>
                                )}
                              </React.Fragment>
                            </CardContent>
                          </Card>
                        ))}
                      </Box>
                      {(ind < 9) && (ind === HostelTypes?.length - 1) && (
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "flex-end",
                      margin: "0px 17px",
                    }}
                  >
                    <Button
                      style={{
                        padding: "6px 0px",
                        width: "25%",
                        fontSize: "1rem",
                      }}
                      onClick={() => {
                        setHostelTypes((prev) => [...prev, initialHostelTypes]);
                      }}
                      variant="contained"
                    >
                      Add more hostel type
                    </Button>
                  </Box>
)}
                      </CardContent>
                  </Card>
                    </React.Fragment>
                    
                  ))}



                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "flex-start",
                      alignItems: "center",
                      backgroundColor: "#FCFCFD",
                      padding: 2,
                      border: "1px solid #E5E7EB",
                      marginTop: 7,
                    }}
                  >
                    <FormIcon style={{ marginRight: "10px" }} />
                    <Typography
                      sx={{
                        fontSize: "20px",
                        fontWeight: 600,
                        color: "black",
                      }}
                    >
                      Services & Facilities
                    </Typography>
                  </Box>

                  {serviceFacility?.map((item, index) => (
                    <React.Fragment key={index}>
                      <Box style={{ padding: "0px 17px 17px 17px" }}>
                      {allLanguages.map((lang) => (
                        <>
                      
                        <Box sx={{mb: 2}} key={lang.value} >
                          <Typography sx={{fontWeight : 700, fontSize : '1.4rem', mt : 2}}>{lang.name}</Typography>
                    <Stack
                      mt={5}
                      direction="row"
                      alignItems="center"
                      justifyContent="space-between"
                    >
                      <InputLabel
                        sx={{
                          mt: "20px",
                          mb: 1,
                          fontSize: "18px",
                          fontWeight: 600,
                          color: "black",
                        }}
                      >
                        {Boolean(errors[`serviceFacility_Title_${index + 1}`]?.[lang.value])
                          ? "Title*"
                          : "Title"}
                      </InputLabel>

                      {index > 0 && (
                        <IconButton
                          onClick={() => handleDeleteServicesFacility(index)}
                        >
                          {" "}
                          <ClearIcon
                            sx={{ color: "#f37777", fontSize: "30px" }}
                          />
                        </IconButton>
                      )}
                    </Stack>
                    <Controller
                      name={`serviceFacility_Title_${index + 1}.${lang.value}`}
                      rules={{ required: true }}
                      control={control}
                      render={({ field }) => (
                        <TextField
                          placeholder="Enter title"
                          error={
                            Boolean(
                              errors[`serviceFacility_Title_${index + 1}`]?.[lang.value]
                            )
                              ? true
                              : false
                          }
                          {...field}
                          sx={{
                            mt: 0,
                            backgroundColor: "rgb(249, 250, 251)",
                            borderRadius: 0,
                            "& .MuiInputBase-input": {
                              color: Boolean(
                                errors[`serviceFacility_Title_${index + 1}`]?.[lang.value]
                              )
                                ? "red"
                                : "black",
                            },
                            "& .MuiOutlinedInput-root": {
                              "& fieldset": {
                                borderColor: Boolean(
                                  errors[`serviceFacility_Title_${index + 1}`]?.[lang.value]
                                )
                                  ? "#ff5e74"
                                  : "rgba(0, 0, 0, 0.23)",
                              },
                              "&:hover fieldset": {
                                borderColor: Boolean(
                                  errors[`serviceFacility_Title_${index + 1}`]?.[lang.value]
                                )
                                  ? "#ff5e74"
                                  : "rgba(0, 0, 0, 0.23)",
                              },
                              "&.Mui-focused fieldset": {
                                borderColor: Boolean(
                                  errors[`serviceFacility_Title_${index + 1}`]?.[lang.value]
                                )
                                  ? "#ff5e74"
                                  : "rgba(0, 0, 0, 0.23)",
                              },
                            },
                          }}
                        />
                      )}
                    />

                    {Boolean(errors[`serviceFacility_Title_${index + 1}`]?.[lang.value]) ? (
                      <Typography
                        style={{ color: "#ff5e74", margin: "0.3rem" }}
                      >
                        Please enter title
                      </Typography>
                    ) : null}

                    <Box sx={{ paddingBottom: "30px" }}>
                      <InputLabel
                        sx={{
                          mt: "20px",
                          mb: 1,
                          fontSize: "18px",
                          fontWeight: 600,
                          color: "black",
                        }}
                      >
                        {Boolean(errors[`serviceFacility_des_${index + 1}`]?.[lang.value])
                          ? "Description*"
                          : "Description"}
                      </InputLabel>
                      <Controller
                        name={`serviceFacility_des_${index + 1}.${lang.value}`}
                        rules={{ required: true }}
                        control={control}
                        render={({ field }) => (
                          <ReactQuill
                            style={{ height: "180px" }}
                            modules={modules}
                            {...field}
                          />
                        )}
                      />
                    </Box>
                    <Box style={{ marginTop: "1rem" }}>
                      {Boolean(errors[`serviceFacility_des_${index + 1}`]?.[lang.value]) ? (
                        <Typography
                          style={{ color: "#ff5e74", margin: "0.3rem" }}
                        >
                          Please enter description
                        </Typography>
                      ) : null}
                    </Box>
                    </Box>
                    <Divider sx={{mt : 2, mb : 2}}/>
                    </>
                    ))}

                        <InputLabel
                          sx={{
                            mt: "20px",
                            mb: 1,
                            fontSize: "18px",
                            fontWeight: 600,
                            color: "black",
                          }}
                        >
                          {Boolean(errors[`serviceFacility_Image_${index + 1}`])
                            ? "Image*"
                            : "Image"}
                        </InputLabel>

                        {item?.img ? (
                          <>
                            <Box>
                              <Stack
                                mt={2}
                                direction="row"
                                justifyContent="space-between"
                                alignItems="center"
                                padding="23px"
                                borderRadius="8px"
                                sx={{ border: ".5px solid #1A2461" }}
                              >
                                <Typography
                                  variant="h9_1"
                                  sx={{
                                    display: "flex",
                                    alignItems: "center",
                                    gap: "10px",
                                  }}
                                >
                                  <ImgIcon />
                                  {item?.img}
                                </Typography>
                                <ClearIcon
                                  onClick={() =>
                                    handleServiceImageDelete(index)
                                  }
                                  sx={{ color: "#1A2461" }}
                                />
                              </Stack>
                            </Box>
                          </>
                        ) : (
                          <>
                            <Controller
                              name={`serviceFacility_Image_${index + 1}`}
                              rules={{ required: true }}
                              control={control}
                              render={({ field }) => (
                                <input
                                    style={{
                                      border : '1px solid rgba(0, 0, 0, 0.23)',
                                      width : '100%',
                                      padding : '15px 10px',
                                      borderRadius : '8px'
                                    }}
                                  type="file"
                                  accept="image/*"
                                  onChange={(e) => {
                                    field.onChange(e.target.files[0]);
                                  }}
                                />
                              )}
                            />
                            {Boolean(
                              errors[`serviceFacility_Image_${index + 1}`]
                            ) ? (
                              <Typography
                                style={{ color: "#ff5e74", margin: "0.3rem" }}
                              >
                                Please select an image
                              </Typography>
                            ) : null}
                          </>
                        )}

                        <InputLabel
                          sx={{
                            mt: "20px",
                            mb: 1,
                            fontSize: "18px",
                            fontWeight: 600,
                            color: "black",
                          }}
                        >
                          {Boolean(errors[`serviceFacility_Icon_${index + 1}`])
                            ? "Icon*"
                            : "Icon"}
                        </InputLabel>

                        {item?.icon ? (
                          <>
                            <Stack
                              mt={2}
                              direction="row"
                              justifyContent="space-between"
                              alignItems="center"
                              padding="23px"
                              borderRadius="8px"
                              sx={{ border: ".5px solid #1A2461" }}
                            >
                              <Typography
                                variant="h9_1"
                                sx={{
                                  display: "flex",
                                  alignItems: "center",
                                  gap: "10px",
                                }}
                              >
                                <ImgIcon />
                                {item?.icon}
                              </Typography>
                              <ClearIcon
                                onClick={() => handleServiceIconDelete(index)}
                                sx={{ color: "#1A2461" }}
                              />
                            </Stack>
                          </>
                        ) : (
                          <>
                            <Controller
                              name={`serviceFacility_Icon_${index + 1}`}
                              rules={{ required: true }}
                              control={control}
                              render={({ field }) => (
                                <input
                                style={{
                                  border : '1px solid rgba(0, 0, 0, 0.23)',
                                  width : '100%',
                                  padding : '15px 10px',
                                  borderRadius : '8px'
                                }}
                                  type="file"
                                  accept="image/*"
                                  onChange={(e) =>
                                    field.onChange(e.target.files[0])
                                  }
                                />
                              )}
                            />
                            {Boolean(
                              errors[`serviceFacility_Icon_${index + 1}`]
                            ) ? (
                              <Typography
                                style={{ color: "#ff5e74", margin: "0.3rem" }}
                              >
                                Please select an icon
                              </Typography>
                            ) : null}
                          </>
                        )}
                      </Box>
                    </React.Fragment>
                  ))}

                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "flex-end",
                      padding: "0px 17px",
                    }}
                  >
                    <Button
                      style={{
                        padding: "6px 0px",
                        width: "25%",
                        fontSize: "1rem",
                      }}
                      onClick={() => {
                        setServicesFacility((prev) => [
                          ...prev,
                          initialServiceFacility,
                        ]);
                      }}
                      variant="contained"
                    >
                      Add more Services & Facility
                    </Button>
                  </Box>

                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "flex-start",
                      alignItems: "center",
                      backgroundColor: "#FCFCFD",
                      padding: 2,
                      border: "1px solid #E5E7EB",
                      marginTop: 7,
                    }}
                  >
                    <FormIcon style={{ marginRight: "10px" }} />
                    <Typography
                      sx={{
                        fontSize: "20px",
                        fontWeight: 600,
                        color: "black",
                      }}
                    >
                      Views
                    </Typography>
                  </Box>

                  {ViewsData?.map((item, index) => (
                    <>
                      <Box style={{ padding: "0px 17px 17px 17px" }}>
                         {allLanguages.map((lang) => (
                        <>
                      
                        <Box sx={{mb: 2}} key={lang.value} > 
                          <Typography sx={{fontWeight : 700, fontSize : '1.4rem', mt : 2}}>{lang.name}</Typography>
                    <Stack
                      mt={2}
                      direction="row"
                      alignItems="center"
                      justifyContent="space-between"
                    >
                      <InputLabel
                        sx={{
                          mt: "0px",
                          mb: 1,
                          fontSize: "18px",
                          fontWeight: 600,
                          color: "black",
                        }}
                      >
                        {Boolean(errors[`Views_Title_${index + 1}`]?.[lang.value])
                          ? "Title*"
                          : "Title"}
                      </InputLabel>
                      {index > 0 && (
                        <IconButton onClick={() => handleDeleteViews(index)}>
                          {" "}
                          <ClearIcon
                            sx={{ color: "#f37777", fontSize: "30px" }}
                          />
                        </IconButton>
                      )}
                    </Stack>
                    <Controller
                      name={`Views_Title_${index + 1}.${lang.value}`}
                      rules={{ required: true }}
                      control={control}
                      render={({ field }) => (
                        <TextField
                          placeholder="Enter title"
                          error={
                            Boolean(errors[`Views_Title_${index + 1}`]?.[lang.value])
                              ? true
                              : false
                          }
                          {...field}
                          sx={{
                            mt: 0,
                            backgroundColor: "rgb(249, 250, 251)",
                            borderRadius: 0,
                            "& .MuiInputBase-input": {
                              color: Boolean(errors[`Views_Title_${index + 1}`]?.[lang.value])
                                ? "red"
                                : "black",
                            },
                            "& .MuiOutlinedInput-root": {
                              "& fieldset": {
                                borderColor: Boolean(
                                  errors[`Views_Title_${index + 1}`]?.[lang.value]
                                )
                                  ? "#ff5e74"
                                  : "rgba(0, 0, 0, 0.23)",
                              },
                              "&:hover fieldset": {
                                borderColor: Boolean(
                                  errors[`Views_Title_${index + 1}`]?.[lang.value]
                                )
                                  ? "#ff5e74"
                                  : "rgba(0, 0, 0, 0.23)",
                              },
                              "&.Mui-focused fieldset": {
                                borderColor: Boolean(
                                  errors[`Views_Title_${index + 1}`]?.[lang.value]
                                )
                                  ? "#ff5e74"
                                  : "rgba(0, 0, 0, 0.23)",
                              },
                            },
                          }}
                        />
                      )}
                    />
                    {Boolean(errors[`Views_Title_${index + 1}`]?.[lang.value]) ? (
                      <Typography
                        style={{ color: "#ff5e74", margin: "0.3rem" }}
                      >
                        Please enter title
                      </Typography>
                    ) : null}
                    

                </Box>
                <Divider sx={{mt : 2, mb : 2}}/>
                </>
                ))}

                        <InputLabel
                          sx={{
                            mt: "10px",
                            mb: 1,
                            fontSize: "18px",
                            fontWeight: 600,
                            color: "black",
                          }}
                        >
                          {Boolean(errors[`Views_Image_${index + 1}`])
                            ? "Image*"
                            : "Image"}
                        </InputLabel>

                        {item?.img ? (
                          <>
                            <Stack
                              mt={2}
                              direction="row"
                              justifyContent="space-between"
                              alignItems="center"
                              padding="13px"
                              borderRadius="8px"
                              sx={{ border: ".5px solid #1A2461" }}
                            >
                              <Typography
                                variant="h9_1"
                                sx={{
                                  display: "flex",
                                  alignItems: "center",
                                  gap: "10px",
                                }}
                              >
                                {/* <ImgIcon /> */}
                                <Box sx={{width : '100px', height : '100px'}} component='img' src={process.env.REACT_APP_FILE_PATH + item?.img}/>
                                {item?.img}
                              </Typography>
                              <ClearIcon
                                onClick={() => handleViewsImageDelete(index)}
                                sx={{ color: "#1A2461", ':hover' : {cursor : 'pointer'} }}
                              />
                            </Stack>
                          </>
                        ) : (
                          <>
                            <Controller
                              name={`Views_Image_${index + 1}`}
                              rules={{ required: true }}
                              control={control}
                              render={({ field }) => (
                                <input
                                  style={{
                                    border : '1px solid rgba(0, 0, 0, 0.23)',
                                    width : '100%',
                                    padding : '15px 10px',
                                    borderRadius : '8px'
                                  }}
                                  type="file"
                                  accept="image/*"
                                  onChange={(e) => {
                                    field.onChange(e.target.files[0]);
                                  }}
                                />
                              )}
                            />
                            {Boolean(errors[`Views_Image_${index + 1}`]) ? (
                              <Typography
                                style={{ color: "#ff5e74", margin: "0.3rem" }}
                              >
                                Please select an image
                              </Typography>
                            ) : null}
                          </>
                        )}
                      </Box>
                    </>
                  ))}

                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "flex-end",
                      padding: "0px 17px",
                    }}
                  >
                    <Button
                      style={{
                        padding: "6px 0px",
                        width: "25%",
                        fontSize: "1rem",
                      }}
                      onClick={() => {
                        setViewsData((prev) => [
                          ...prev,
                          { img: "", title: "" },
                        ]);
                      }}
                      variant="contained"
                    >
                      Add more Views
                    </Button>
                  </Box>

                  <Box
                sx={{
                  display: "flex",
                  justifyContent: "flex-start",
                  alignItems: "center",
                  backgroundColor: "#FCFCFD",
                  padding: 2,
                  border: "1px solid #E5E7EB",
                  marginTop: 7,
                }}
              >
                <FormIcon style={{ marginRight: "10px" }} />
                <Typography
                  sx={{
                    fontSize: "20px",
                    fontWeight: 600,
                    color: "black",
                  }}
                >
                  Map
                </Typography>
              </Box>

              <Box style={{ padding: "25px 17px 17px 17px" }}>
                <InputLabel
                  sx={{
                    mb: 1,
                    fontSize: "18px",
                    fontWeight: 600,
                    color: "black",
                  }}
                >
                  {errors?.Location?.latitude ? "Latitude of hostel*" : "Latitude of hostel"}
                </InputLabel>
                <Controller
                  name={`Location.latitude`}
                  rules={{
                    required: "Latitude is required",
                    validate: (value) =>
                      !isNaN(value) && Number(value) >= -90 && Number(value) <= 90
                        ? true
                        : "Latitude must be a number between -90 and 90",
                  }}
                  control={control}
                  render={({ field }) => (
                    <TextField
                      {...field}
                      error={Boolean(errors?.Location?.latitude) ? true : false}
                      placeholder="Enter latitude"
                      sx={{
                        mt: 0,
                        backgroundColor: "rgb(249, 250, 251)",
                        borderRadius: 0,
                        "& .MuiInputBase-input": {
                          color: errors?.Location?.latitude ? "red" : "black",
                        },
                        "& .MuiOutlinedInput-root": {
                          "& fieldset": {
                            borderColor: errors?.Location?.latitude
                              ? "#ff5e74"
                              : "rgba(0, 0, 0, 0.23)",
                          },
                          "&:hover fieldset": {
                            borderColor: errors?.Location?.latitude
                              ? "#ff5e74"
                              : "rgba(0, 0, 0, 0.23)",
                          },
                          "&.Mui-focused fieldset": {
                            borderColor: errors?.Location?.latitude
                              ? "#ff5e74"
                              : "rgba(0, 0, 0, 0.23)",
                          },
                        },
                      }}
                    />
                  )}
                />
                {errors?.Location?.latitude ? (
                  <Typography style={{ color: "#ff5e74", margin: "0.3rem" }}>
                    {errors?.Location?.latitude?.message}
                  </Typography>
                ) : null}
              </Box>


              <Box style={{ padding: "25px 17px 17px 17px" }}>
                <InputLabel
                  sx={{
                    mb: 1,
                    fontSize: "18px",
                    fontWeight: 600,
                    color: "black",
                  }}
                >
                  {errors?.Location?.longitude ? "Longitude of hostel*" : "Longitude of hostel"}
                </InputLabel>
                <Controller
                  name={`Location.longitude`}
                  rules={{
                    required: "Longitude is required",
                    validate: (value) =>
                      !isNaN(value) && Number(value) >= -180 && Number(value) <= 180
                        ? true
                        : "Longitude must be a number between -180 and 180",
                  }}
                  control={control}
                  render={({ field }) => (
                    <TextField
                      {...field}
                      error={Boolean(errors?.Location?.longitude) ? true : false}
                      placeholder="Enter longitude"
                      sx={{
                        mt: 0,
                        backgroundColor: "rgb(249, 250, 251)",
                        borderRadius: 0,
                        "& .MuiInputBase-input": {
                          color: errors?.Location?.longitude ? "red" : "black",
                        },
                        "& .MuiOutlinedInput-root": {
                          "& fieldset": {
                            borderColor: errors?.Location?.longitude
                              ? "#ff5e74"
                              : "rgba(0, 0, 0, 0.23)",
                          },
                          "&:hover fieldset": {
                            borderColor: errors?.Location?.longitude
                              ? "#ff5e74"
                              : "rgba(0, 0, 0, 0.23)",
                          },
                          "&.Mui-focused fieldset": {
                            borderColor: errors?.Location?.longitude
                              ? "#ff5e74"
                              : "rgba(0, 0, 0, 0.23)",
                          },
                        },
                      }}
                    />
                  )}
                />
                {errors?.Location?.longitude ? (
                  <Typography style={{ color: "#ff5e74", margin: "0.3rem" }}>
                   {errors?.Location?.longitude?.message}
                  </Typography>
                ) : null}
              </Box>

              <Divider sx={{mt : 2, mb : 2}}/>

              <Typography sx={{fontSize : '1.5rem', fontWeight : 'bold', ml : 2}}>Near by MRT Station</Typography>
              <Divider sx={{mt : 2}}/>
              

                
              {mrtFields.map((mrt, i) => (
              <>
              <Card sx={{ mx : 2, mt : 2, background : '#f5f5f5'}}>
                <CardContent>
                <Box sx={{display : 'flex', justifyContent : 'flex-end'}}>
                    {i > 0 && (
                        <IconButton onClick={() => handleDeleteMrtStation(i)}>
                          {" "}
                          <ClearIcon
                            sx={{ color: "#f37777", fontSize: "30px" }}
                          />
                        </IconButton>
                      )}
                    </Box>
                    {allLanguages.map((lang) => (
                      <>
                      <Box style={{ padding: "25px 17px 17px 17px" }}>
                      <Typography sx={{fontSize : '1.3rem', fontWeight : 'bold'}}>{lang.name}</Typography>
                      <InputLabel
                        sx={{
                          mb: 1,
                          fontSize: "18px",
                          fontWeight: 600,
                          color: "black",
                          mt: 2
                        }}
                      >
                        {errors?.[`mrtStations.${i}.name.${lang.value}`] ? "Name*" : "Name"}
                      </InputLabel>
                      <Controller
                        name={`mrtStations.${i}.name.${lang.value}`}
                        control={control}
                        rules={{ required: true }}
                        render={({ field }) => (
                          <TextField
                            {...field}
                            placeholder="Enter name"
                            error={Boolean(errors?.mrtStations?.[i]?.name?.[lang.value])}
                            sx={{
                              mt: 0,
                              backgroundColor: "rgb(249, 250, 251)",
                              borderRadius: 0,
                              "& .MuiInputBase-input": {
                                color: errors?.mrtStations?.[i]?.name?.[lang.value] ? "red" : "black",
                              },
                              "& .MuiOutlinedInput-root": {
                                "& fieldset": {
                                  borderColor: errors?.mrtStations?.[i]?.name?.[lang.value]
                                    ? "#ff5e74"
                                    : "rgba(0, 0, 0, 0.23)",
                                },
                                "&:hover fieldset": {
                                  borderColor: errors?.mrtStations?.[i]?.name?.[lang.value]
                                    ? "#ff5e74"
                                    : "rgba(0, 0, 0, 0.23)",
                                },
                                "&.Mui-focused fieldset": {
                                  borderColor: errors?.mrtStations?.[i]?.name?.[lang.value]
                                    ? "#ff5e74"
                                    : "rgba(0, 0, 0, 0.23)",
                                },
                              },
                            }}
                          />
                        )}
                      />
                      {errors?.mrtStations?.[i]?.name?.[lang.value] && (
                        <Typography sx={{ color: "#ff5e74", mt: 1 }}>
                          Please enter name
                        </Typography>
                      )}
                      </Box>
                      </>
                    ))}

                    <Divider sx={{mt : 2, mb : 2}}/>
                    <Box key={i} sx={{ padding: "25px 17px 17px 17px" }}>
                      {/* Latitude */}
                      <InputLabel
                        sx={{
                          mb: 1,
                          fontSize: "18px",
                          fontWeight: 600,
                          color: "black",
                        }}
                      >
                        {errors?.[`mrtStations.${i}.coOrdinates.latitude`] ? "Latitude*" : "Latitude"}
                      </InputLabel>
                      <Controller
                        name={`mrtStations.${i}.coOrdinates.latitude`}
                        control={control}
                        rules={{
                          required: "Latitude is required",
                          validate: (value) =>
                            !isNaN(value) && Number(value) >= -90 && Number(value) <= 90
                              ? true
                              : "Latitude must be a number between -90 and 90",
                        }}
                        render={({ field }) => (
                          <TextField
                            {...field}
                            placeholder="Enter latitude"
                            error={Boolean(errors?.mrtStations?.[i]?.coOrdinates?.latitude) ? true : false}
                            sx={{
                              mt: 0,
                              backgroundColor: "rgb(249, 250, 251)",
                              borderRadius: 0,
                              "& .MuiInputBase-input": {
                                color: errors?.mrtStations?.[i]?.coOrdinates?.latitude ? "red" : "black",
                              },
                              "& .MuiOutlinedInput-root": {
                                "& fieldset": {
                                  borderColor: errors?.mrtStations?.[i]?.coOrdinates?.latitude
                                    ? "#ff5e74"
                                    : "rgba(0, 0, 0, 0.23)",
                                },
                                "&:hover fieldset": {
                                  borderColor: errors?.mrtStations?.[i]?.coOrdinates?.latitude
                                    ? "#ff5e74"
                                    : "rgba(0, 0, 0, 0.23)",
                                },
                                "&.Mui-focused fieldset": {
                                  borderColor: errors?.mrtStations?.[i]?.coOrdinates?.latitude
                                    ? "#ff5e74"
                                    : "rgba(0, 0, 0, 0.23)",
                                },
                              },
                            }}
                          />
                        )}
                      />
                      {errors?.mrtStations?.[i]?.coOrdinates?.latitude && (
                        <Typography sx={{ color: "#ff5e74", mt: 1 }}>
                          {errors?.mrtStations?.[i]?.coOrdinates?.latitude?.message}
                        </Typography>
                      )}


                      {/* Latitude */}
                      <InputLabel
                        sx={{
                          mb: 1,
                          mt : 2,
                          fontSize: "18px",
                          fontWeight: 600,
                          color: "black",
                        }}
                      >
                        {errors?.[`mrtStations.${i}.coOrdinates.longitue`] ? "Longitude*" : "Longitude"}
                      </InputLabel>
                      <Controller
                        name={`mrtStations.${i}.coOrdinates.longitude`}
                        control={control}
                        rules={{
                          required: "Longitude is required",
                          validate: (value) =>
                            !isNaN(value) && Number(value) >= -180 && Number(value) <= 180
                              ? true
                              : "Longitude must be a number between -180 and 180",
                        }}
                        render={({ field }) => (
                          <TextField
                            {...field}
                            placeholder="Enter latitude"
                            error={Boolean(errors?.mrtStations?.[i]?.coOrdinates?.longitude) ? true : false}
                            sx={{
                              mt: 0,
                              backgroundColor: "rgb(249, 250, 251)",
                              borderRadius: 0,
                              "& .MuiInputBase-input": {
                                color: errors?.mrtStations?.[i]?.coOrdinates?.longitude ? "red" : "black",
                              },
                              "& .MuiOutlinedInput-root": {
                                "& fieldset": {
                                  borderColor: errors?.mrtStations?.[i]?.coOrdinates?.longitude
                                    ? "#ff5e74"
                                    : "rgba(0, 0, 0, 0.23)",
                                },
                                "&:hover fieldset": {
                                  borderColor: errors?.mrtStations?.[i]?.coOrdinates?.longitude
                                    ? "#ff5e74"
                                    : "rgba(0, 0, 0, 0.23)",
                                },
                                "&.Mui-focused fieldset": {
                                  borderColor: errors?.mrtStations?.[i]?.coOrdinates?.longitude
                                    ? "#ff5e74"
                                    : "rgba(0, 0, 0, 0.23)",
                                },
                              },
                            }}
                          />
                        )}
                      />
                      {errors?.mrtStations?.[i]?.coOrdinates?.longitude && (
                        <Typography sx={{ color: "#ff5e74", mt: 1 }}>
                         {errors?.mrtStations?.[i]?.coOrdinates?.longitude?.message}
                        </Typography>
                      )}
                      {/* Walk */}
                      <InputLabel
                        sx={{
                          mb: 1,
                          fontSize: "18px",
                          fontWeight: 600,
                          color: "black",
                          mt: 2
                        }}
                      >
                        {errors?.[`mrtStations.${i}.walk`] ? "Walk (minutes)*" : "Walk (minutes)"}
                      </InputLabel>
                      <Controller
                        name={`mrtStations.${i}.walk`}
                        control={control}
                        rules={{
                          required: "Walk time is required",
                          validate: (value) =>
                            !isNaN(value) && Number(value) >= 0 || "Please enter a valid number",
                        }}
                        render={({ field }) => (
                          <TextField
                            {...field}
                            placeholder="Enter walk time"
                            error={Boolean(errors?.mrtStations?.[i]?.walk) ? true : false}
                            sx={{
                              mt: 0,
                              backgroundColor: "rgb(249, 250, 251)",
                              borderRadius: 0,
                              "& .MuiInputBase-input": {
                                color: errors?.mrtStations?.[i]?.walk ? "red" : "black",
                              },
                              "& .MuiOutlinedInput-root": {
                                "& fieldset": {
                                  borderColor: errors?.mrtStations?.[i]?.walk
                                    ? "#ff5e74"
                                    : "rgba(0, 0, 0, 0.23)",
                                },
                                "&:hover fieldset": {
                                  borderColor: errors?.mrtStations?.[i]?.walk
                                    ? "#ff5e74"
                                    : "rgba(0, 0, 0, 0.23)",
                                },
                                "&.Mui-focused fieldset": {
                                  borderColor: errors?.mrtStations?.[i]?.walk
                                    ? "#ff5e74"
                                    : "rgba(0, 0, 0, 0.23)",
                                },
                              },
                            }}
                          />
                        )}
                      />
                      {errors?.mrtStations?.[i]?.walk && (
                        <Typography sx={{ color: "#ff5e74", mt: 1 }}>
                          {errors?.mrtStations?.[i]?.walk?.message}
                        </Typography>
                      )}
                    </Box>
                    
                   
                    </CardContent>
              </Card>
                    </>
                  ))}
                  
                  <Box sx={{display : 'flex', justifyContent : 'flex-end'}}>
                  <Button sx={{mt : 2, mr : 2}} variant='contained' onClick={() => addNewMrtStation()}>Add More MRT station</Button>
                  </Box>

              <Divider sx={{mt : 2, mb : 2}}/>
<Typography sx={{fontSize : '1.5rem', fontWeight : 'bold', ml : 2}}>Near by Bus Station</Typography>
<Divider sx={{mt : 2}}/>
              
              {busFields.map((mrt, i) => (
<>
<Card sx={{ mx : 2, mt : 2, background : '#f5f5f5'}}>
                <CardContent>
<Box sx={{display : 'flex', justifyContent : 'flex-end'}}>
                    {i > 0 && (
                        <IconButton onClick={() => handleDeleteBusStation(i)}>
                          {" "}
                          <ClearIcon
                            sx={{ color: "#f37777", fontSize: "30px" }}
                          />
                        </IconButton>
                      )}
                    </Box>
                    {allLanguages.map((lang) => (
                      <>
                      <Box style={{ padding: "25px 17px 17px 17px" }}>
                      <Typography sx={{fontSize : '1.3rem', fontWeight : 'bold'}}>{lang.name}</Typography>
                      <InputLabel
                        sx={{
                          mb: 1,
                          fontSize: "18px",
                          fontWeight: 600,
                          color: "black",
                          mt: 2
                        }}
                      >
                        {errors?.[`busStations.${i}.name.${lang.value}`] ? "Name*" : "Name"}
                      </InputLabel>
                      <Controller
                        name={`busStations.${i}.name.${lang.value}`}
                        control={control}
                        rules={{ required: true }}
                        render={({ field }) => (
                          <TextField
                            {...field}
                            placeholder="Enter name"
                            error={Boolean(errors?.busStations?.[i]?.name?.[lang.value]) ? true : false}
                            sx={{
                              mt: 0,
                              backgroundColor: "rgb(249, 250, 251)",
                              borderRadius: 0,
                              "& .MuiInputBase-input": {
                                color: errors?.busStations?.[i]?.name?.[lang.value] ? "red" : "black",
                              },
                              "& .MuiOutlinedInput-root": {
                                "& fieldset": {
                                  borderColor: errors?.busStations?.[i]?.name?.[lang.value]
                                    ? "#ff5e74"
                                    : "rgba(0, 0, 0, 0.23)",
                                },
                                "&:hover fieldset": {
                                  borderColor: errors?.busStations?.[i]?.name?.[lang.value]
                                    ? "#ff5e74"
                                    : "rgba(0, 0, 0, 0.23)",
                                },
                                "&.Mui-focused fieldset": {
                                  borderColor: errors?.busStations?.[i]?.name?.[lang.value]
                                    ? "#ff5e74"
                                    : "rgba(0, 0, 0, 0.23)",
                                },
                              },
                            }}
                          />
                        )}
                      />
                      {errors?.busStations?.[i]?.name?.[lang.value] && (
                        <Typography sx={{ color: "#ff5e74", mt: 1 }}>
                          Please enter name
                        </Typography>
                      )}
                      </Box>
                      </>
                    ))}

                    <Divider sx={{mt : 2, mb : 2}}/>
                    <Box key={i} sx={{ padding: "25px 17px 17px 17px" }}>
                      {/* Latitude */}
                      <InputLabel
                        sx={{
                          mb: 1,
                          fontSize: "18px",
                          fontWeight: 600,
                          color: "black",
                        }}
                      >
                        {errors?.[`busStations.${i}.coOrdinates.latitude`] ? "Latitude*" : "Latitude"}
                      </InputLabel>
                      <Controller
                        name={`busStations.${i}.coOrdinates.latitude`}
                        control={control}
                        rules={{
                          required: "Latitude is required",
                          validate: (value) =>
                            !isNaN(value) && Number(value) >= -90 && Number(value) <= 90
                              ? true
                              : "Latitude must be a number between -90 and 90",
                        }}
                        render={({ field }) => (
                          <TextField
                            {...field}
                            placeholder="Enter latitude"
                            error={Boolean(errors?.busStations?.[i]?.coOrdinates?.latitude) ? true : false}
                            sx={{
                              mt: 0,
                              backgroundColor: "rgb(249, 250, 251)",
                              borderRadius: 0,
                              "& .MuiInputBase-input": {
                                color: errors?.busStations?.[i]?.coOrdinates?.latitude ? "red" : "black",
                              },
                              "& .MuiOutlinedInput-root": {
                                "& fieldset": {
                                  borderColor: errors?.busStations?.[i]?.coOrdinates?.latitude
                                    ? "#ff5e74"
                                    : "rgba(0, 0, 0, 0.23)",
                                },
                                "&:hover fieldset": {
                                  borderColor: errors?.busStations?.[i]?.coOrdinates?.latitude
                                    ? "#ff5e74"
                                    : "rgba(0, 0, 0, 0.23)",
                                },
                                "&.Mui-focused fieldset": {
                                  borderColor: errors?.busStations?.[i]?.coOrdinates?.latitude
                                    ? "#ff5e74"
                                    : "rgba(0, 0, 0, 0.23)",
                                },
                              },
                            }}
                          />
                        )}
                      />
                      {errors?.busStations?.[i]?.coOrdinates?.latitude && (
                        <Typography sx={{ color: "#ff5e74", mt: 1 }}>
                          {errors?.busStations?.[i]?.coOrdinates?.latitude?.message}
                        </Typography>
                      )}


                 
                      <InputLabel
                        sx={{
                          mb: 1,
                          mt : 1,
                          fontSize: "18px",
                          fontWeight: 600,
                          color: "black",
                        }}
                      >
                        {errors?.[`busStations.${i}.coOrdinates.longitude`] ? "Longitude*" : "Longitude"}
                      </InputLabel>
                      <Controller
                        name={`busStations.${i}.coOrdinates.longitude`}
                        control={control}
                        rules={{
                          required: "Longitude is required",
                          validate: (value) =>
                            !isNaN(value) && Number(value) >= -180 && Number(value) <= 180
                              ? true
                              : "Longitude must be a number between -180 and 180",
                        }}
                        render={({ field }) => (
                          <TextField
                            {...field}
                            placeholder="Enter longitude"
                            error={Boolean(errors?.busStations?.[i]?.coOrdinates?.longitude) ? true : false}
                            sx={{
                              mt: 0,
                              backgroundColor: "rgb(249, 250, 251)",
                              borderRadius: 0,
                              "& .MuiInputBase-input": {
                                color: errors?.busStations?.[i]?.coOrdinates?.longitude ? "red" : "black",
                              },
                              "& .MuiOutlinedInput-root": {
                                "& fieldset": {
                                  borderColor: errors?.busStations?.[i]?.coOrdinates?.longitude
                                    ? "#ff5e74"
                                    : "rgba(0, 0, 0, 0.23)",
                                },
                                "&:hover fieldset": {
                                  borderColor: errors?.busStations?.[i]?.coOrdinates?.longitude
                                    ? "#ff5e74"
                                    : "rgba(0, 0, 0, 0.23)",
                                },
                                "&.Mui-focused fieldset": {
                                  borderColor: errors?.busStations?.[i]?.coOrdinates?.longitude
                                    ? "#ff5e74"
                                    : "rgba(0, 0, 0, 0.23)",
                                },
                              },
                            }}
                          />
                        )}
                      />
                      {errors?.busStations?.[i]?.coOrdinates?.longitude && (
                        <Typography sx={{ color: "#ff5e74", mt: 1 }}>
                          {errors?.busStations?.[i]?.coOrdinates?.longitude?.message}
                        </Typography>
                      )}


                      {/* Walk */}
                      <InputLabel
                        sx={{
                          mb: 1,
                          fontSize: "18px",
                          fontWeight: 600,
                          color: "black",
                          mt: 2
                        }}
                      >
                        {errors?.[`busStations.${i}.walk`] ? "Walk (minutes)*" : "Walk (minutes)"}
                      </InputLabel>
                      <Controller
                        name={`busStations.${i}.walk`}
                        control={control}
                        rules={{
                          required: "Walk time is required",
                          validate: (value) =>
                            !isNaN(value) && Number(value) >= 0 || "Please enter a valid number",
                        }}
                        render={({ field }) => (
                          <TextField
                            {...field}
                            placeholder="Enter walk time"
                            error={Boolean(errors?.busStations?.[i]?.walk) ? true : false}
                            sx={{
                              mt: 0,
                              backgroundColor: "rgb(249, 250, 251)",
                              borderRadius: 0,
                              "& .MuiInputBase-input": {
                                color: errors?.busStations?.[i]?.walk ? "red" : "black",
                              },
                              "& .MuiOutlinedInput-root": {
                                "& fieldset": {
                                  borderColor: errors?.busStations?.[i]?.walk
                                    ? "#ff5e74"
                                    : "rgba(0, 0, 0, 0.23)",
                                },
                                "&:hover fieldset": {
                                  borderColor: errors?.busStations?.[i]?.walk
                                    ? "#ff5e74"
                                    : "rgba(0, 0, 0, 0.23)",
                                },
                                "&.Mui-focused fieldset": {
                                  borderColor: errors?.busStations?.[i]?.walk
                                    ? "#ff5e74"
                                    : "rgba(0, 0, 0, 0.23)",
                                },
                              },
                            }}
                          />
                        )}
                      />
                      {errors?.busStations?.[i]?.walk && (
                        <Typography sx={{ color: "#ff5e74", mt: 1 }}>
                          {errors?.busStations?.[i]?.walk?.message}
                        </Typography>
                      )}
                    </Box>
                    </CardContent>
                    </Card>
                    </>
                  ))}

                  <Box sx={{display : 'flex', justifyContent : 'flex-end'}}>
                  <Button sx={{mt : 2, mr : 2}} variant='contained' onClick={() => addNewBusStation()}>Add more bus station</Button>
                  </Box>


<Divider sx={{mt : 2, mb : 2}}/>
<Typography sx={{fontSize : '1.5rem', fontWeight : 'bold', ml : 2}}>Tracks</Typography>
<Divider sx={{mt : 2}}/>
              
              {trackFields.map((mrt, i) => (
                  <>
                  <Card sx={{ mx : 2, mt : 2, background : '#f5f5f5'}}>
                  <CardContent>
                  <Box sx={{display : 'flex', justifyContent : 'flex-end'}}>
                    {i > 0 && (
                        <IconButton onClick={() => handleDeleteTrack(i)}>
                          {" "}
                          <ClearIcon
                            sx={{ color: "#f37777", fontSize: "30px" }}
                          />
                        </IconButton>
                      )}
                    </Box>
              

                    
                    {allLanguages.map((lang) => (
                      <>
                      <Box style={{ padding: "25px 17px 17px 17px" }}>
                      <Typography sx={{fontSize : '1.3rem', fontWeight : 'bold'}}>{lang.name}</Typography>
                      <InputLabel
                        sx={{
                          mb: 1,
                          fontSize: "18px",
                          fontWeight: 600,
                          color: "black",
                          mt: 2
                        }}
                      >
                        {errors?.[`tracks.${i}.name.${lang.value}`] ? "Name*" : "Name"}
                      </InputLabel>
                      <Controller
                        name={`tracks.${i}.name.${lang.value}`}
                        control={control}
                        rules={{ required: true }}
                        render={({ field }) => (
                          <TextField
                            {...field}
                            placeholder="Enter name"
                            error={Boolean(errors?.tracks?.[i]?.name?.[lang.value]) ? true : false}
                            sx={{
                              mt: 0,
                              backgroundColor: "rgb(249, 250, 251)",
                              borderRadius: 0,
                              "& .MuiInputBase-input": {
                                color: errors?.tracks?.[i]?.name?.[lang.value] ? "red" : "black",
                              },
                              "& .MuiOutlinedInput-root": {
                                "& fieldset": {
                                  borderColor: errors?.tracks?.[i]?.name?.[lang.value]
                                    ? "#ff5e74"
                                    : "rgba(0, 0, 0, 0.23)",
                                },
                                "&:hover fieldset": {
                                  borderColor: errors?.tracks?.[i]?.name?.[lang.value]
                                    ? "#ff5e74"
                                    : "rgba(0, 0, 0, 0.23)",
                                },
                                "&.Mui-focused fieldset": {
                                  borderColor: errors?.tracks?.[i]?.name?.[lang.value]
                                    ? "#ff5e74"
                                    : "rgba(0, 0, 0, 0.23)",
                                },
                              },
                            }}
                          />
                        )}
                      />
                      {errors?.tracks?.[i]?.name?.[lang.value] && (
                        <Typography sx={{ color: "#ff5e74", mt: 1 }}>
                          Please enter name
                        </Typography>
                      )}
                      </Box>
                      </>
                    ))}

                    <Divider sx={{mt : 2, mb : 2}}/>
                    <Box key={i} sx={{ padding: "25px 17px 17px 17px" }}>
                      {/* Latitude */}
                      <InputLabel
                        sx={{
                          mb: 1,
                          fontSize: "18px",
                          fontWeight: 600,
                          color: "black",
                        }}
                      >
                        {errors?.[`tracks.${i}.coOrdinates.latitude`] ? "Latitude*" : "Latitude"}
                      </InputLabel>
                      <Controller
                        name={`tracks.${i}.coOrdinates.latitude`}
                        control={control}
                        rules={{
                          required: "Latitude is required",
                          validate: (value) =>
                            !isNaN(value) && Number(value) >= -90 && Number(value) <= 90
                              ? true
                              : "Latitude must be a number between -90 and 90",
                        }}
                        render={({ field }) => (
                          <TextField
                            {...field}
                            placeholder="Enter latitude"
                            error={Boolean(errors?.tracks?.[i]?.coOrdinates?.latitude) ? true : false}
                            sx={{
                              mt: 0,
                              backgroundColor: "rgb(249, 250, 251)",
                              borderRadius: 0,
                              "& .MuiInputBase-input": {
                                color: errors?.tracks?.[i]?.coOrdinates?.latitude ? "red" : "black",
                              },
                              "& .MuiOutlinedInput-root": {
                                "& fieldset": {
                                  borderColor: errors?.tracks?.[i]?.coOrdinates?.latitude
                                    ? "#ff5e74"
                                    : "rgba(0, 0, 0, 0.23)",
                                },
                                "&:hover fieldset": {
                                  borderColor: errors?.tracks?.[i]?.coOrdinates?.latitude
                                    ? "#ff5e74"
                                    : "rgba(0, 0, 0, 0.23)",
                                },
                                "&.Mui-focused fieldset": {
                                  borderColor: errors?.tracks?.[i]?.coOrdinates?.latitude
                                    ? "#ff5e74"
                                    : "rgba(0, 0, 0, 0.23)",
                                },
                              },
                            }}
                          />
                        )}
                      />
                      {errors?.tracks?.[i]?.coOrdinates?.latitude && (
                        <Typography sx={{ color: "#ff5e74", mt: 1 }}>
                          {errors?.tracks?.[i]?.coOrdinates?.latitude?.message}
                        </Typography>
                      )}


                      <InputLabel
                        sx={{
                          mb: 1,
                          mt : 1,
                          fontSize: "18px",
                          fontWeight: 600,
                          color: "black",
                        }}
                      >
                        {errors?.[`tracks.${i}.coOrdinates.longitude`] ? "Longitude*" : "Longitude"}
                      </InputLabel>
                      <Controller
                        name={`tracks.${i}.coOrdinates.longitude`}
                        control={control}
                        rules={{
                          required: "Longitude is required",
                          validate: (value) =>
                            !isNaN(value) && Number(value) >= -180 && Number(value) <= 180
                              ? true
                              : "Longitude must be a number between -180 and 180",
                        }}
                        render={({ field }) => (
                          <TextField
                            {...field}
                            placeholder="Enter longitude"
                            error={Boolean(errors?.tracks?.[i]?.coOrdinates?.longitude) ? true : false}
                            sx={{
                              mt: 0,
                              backgroundColor: "rgb(249, 250, 251)",
                              borderRadius: 0,
                              "& .MuiInputBase-input": {
                                color: errors?.tracks?.[i]?.coOrdinates?.longitude ? "red" : "black",
                              },
                              "& .MuiOutlinedInput-root": {
                                "& fieldset": {
                                  borderColor: errors?.tracks?.[i]?.coOrdinates?.longitude
                                    ? "#ff5e74"
                                    : "rgba(0, 0, 0, 0.23)",
                                },
                                "&:hover fieldset": {
                                  borderColor: errors?.tracks?.[i]?.coOrdinates?.longitude
                                    ? "#ff5e74"
                                    : "rgba(0, 0, 0, 0.23)",
                                },
                                "&.Mui-focused fieldset": {
                                  borderColor: errors?.tracks?.[i]?.coOrdinates?.longitude
                                    ? "#ff5e74"
                                    : "rgba(0, 0, 0, 0.23)",
                                },
                              },
                            }}
                          />
                        )}
                      />
                      {errors?.tracks?.[i]?.coOrdinates?.longitude && (
                        <Typography sx={{ color: "#ff5e74", mt: 1 }}>
                          {errors?.tracks?.[i]?.coOrdinates?.longitude?.message}
                        </Typography>
                      )}

                      {/* Walk */}

                      <InputLabel
                        sx={{
                          mb: 1,
                          fontSize: "18px",
                          fontWeight: 600,
                          color: "black",
                          mt: 2
                        }}
                      >
                        {errors?.[`tracks.${i}.publicTransport`] ? "Public Transport (minutes)*" : "Public Transport (minutes)"}
                      </InputLabel>
                      <Controller
                        name={`tracks.${i}.publicTransport`}
                        control={control}
                        rules={{
                          required: "Public Transport time is required",
                          validate: (value) =>
                            !isNaN(value) && Number(value) >= 0 || "Please enter a valid number",
                        }}
                        render={({ field }) => (
                          <TextField
                            {...field}
                            placeholder="Enter walk time"
                            error={Boolean(errors?.tracks?.[i]?.publicTransport) ? true : false}
                            sx={{
                              mt: 0,
                              backgroundColor: "rgb(249, 250, 251)",
                              borderRadius: 0,
                              "& .MuiInputBase-input": {
                                color: errors?.tracks?.[i]?.publicTransport ? "red" : "black",
                              },
                              "& .MuiOutlinedInput-root": {
                                "& fieldset": {
                                  borderColor: errors?.tracks?.[i]?.publicTransport
                                    ? "#ff5e74"
                                    : "rgba(0, 0, 0, 0.23)",
                                },
                                "&:hover fieldset": {
                                  borderColor: errors?.tracks?.[i]?.publicTransport
                                    ? "#ff5e74"
                                    : "rgba(0, 0, 0, 0.23)",
                                },
                                "&.Mui-focused fieldset": {
                                  borderColor: errors?.tracks?.[i]?.publicTransport
                                    ? "#ff5e74"
                                    : "rgba(0, 0, 0, 0.23)",
                                },
                              },
                            }}
                          />
                        )}
                      />
                      {errors?.tracks?.[i]?.publicTransport && (
                        <Typography sx={{ color: "#ff5e74", mt: 1 }}>
                          {errors?.tracks?.[i]?.publicTransport?.message}
                        </Typography>
                      )}
                    

                      <InputLabel
                        sx={{
                          mb: 1,
                          fontSize: "18px",
                          fontWeight: 600,
                          color: "black",
                          mt: 2
                        }}
                      >
                        {errors?.[`tracks.${i}.walk`] ? "Walk (minutes)*" : "Walk (minutes)"}
                      </InputLabel>
                      <Controller
                        name={`tracks.${i}.walk`}
                        control={control}
                        rules={{
                          required: "Walk time is required",
                          validate: (value) =>
                            !isNaN(value) && Number(value) >= 0 || "Please enter a valid number",
                        }}
                        render={({ field }) => (
                          <TextField
                            {...field}
                            placeholder="Enter walk time"
                            error={Boolean(errors?.tracks?.[i]?.walk) ? true : false}
                            sx={{
                              mt: 0,
                              backgroundColor: "rgb(249, 250, 251)",
                              borderRadius: 0,
                              "& .MuiInputBase-input": {
                                color: errors?.tracks?.[i]?.walk ? "red" : "black",
                              },
                              "& .MuiOutlinedInput-root": {
                                "& fieldset": {
                                  borderColor: errors?.tracks?.[i]?.walk
                                    ? "#ff5e74"
                                    : "rgba(0, 0, 0, 0.23)",
                                },
                                "&:hover fieldset": {
                                  borderColor: errors?.tracks?.[i]?.walk
                                    ? "#ff5e74"
                                    : "rgba(0, 0, 0, 0.23)",
                                },
                                "&.Mui-focused fieldset": {
                                  borderColor: errors?.tracks?.[i]?.walk
                                    ? "#ff5e74"
                                    : "rgba(0, 0, 0, 0.23)",
                                },
                              },
                            }}
                          />
                        )}
                      />
                      {errors?.tracks?.[i]?.walk && (
                        <Typography sx={{ color: "#ff5e74", mt: 1 }}>
                          {errors?.tracks?.[i]?.walk?.message}
                        </Typography>
                      )}
                    </Box>
                    </CardContent>
                    </Card>
                    </>
                  ))}
              
              <Box sx={{display : 'flex', justifyContent : 'flex-end'}}>
                  <Button sx={{mt : 2, mr : 2}} variant='contained' onClick={() => addNewTrack()}>Add more track</Button>
                  </Box>

                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "flex-end",
                      padding: "15px 17px",
                      border: "1px solid #E5E7EB",
                      margin: "30px 0px 0px 0px",
                    }}
                  >
                    <Button
                      variant="contained"
                      
                      style={{

                        backgroundColor: "rgb(14, 94, 132)",
                        fontWeight: 700,
                        width: "25%",
                        padding: "15px 0px",
                        fontSize: "1.1rem",
                      }}
                      type="submit"
                    >
                      Update
                    </Button>
                  </Box>
                </form>
              </CardContent>
            </Card>
          </Box>
        </>
      )}
    </>
  );
};

export default EditHostel;
